import { render, staticRenderFns } from "./ObjectViewer.vue?vue&type=template&id=3f1c4d07&"
import script from "./ObjectViewer.vue?vue&type=script&lang=js&"
export * from "./ObjectViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports